import UiStore from 'stores/UiStore'
import HistoryTracker from 'back-forward-history'

import ProjectStore from 'stores/ProjectStore'
import ResourceStore from 'stores/ResourceStore'
import StoryStore from 'stores/StoryStore'
import ExpertiseStore from 'stores/ExpertiseStore'

import ResourceModel from 'models/ResourceModel'
import StoryModel from 'models/StoryModel'
import FacultyModel from 'models/FacultyModel'
import NotFoundModel from 'models/NotFoundModel'

import { getSingle as projectGetSingle } from 'transport/project'
import { getSingle as resourceGetSingle } from 'transport/resource'
import {
  getSingleNews as newsGetSingle,
  getSingleEvent as eventGetSingle
} from 'transport/story'
import { getSingle as facultyGetSingle } from 'transport/faculty'

import { projectSubmodelFromJS } from 'utils'

const adapters = {
  project: {
    shorts: ProjectStore.projectsMap,
    fulls: ProjectStore.fullProjects,
    get: projectGetSingle,
    fromJS: projectSubmodelFromJS
  },
  resource: {
    shorts: ResourceStore.resourcesMap,
    fulls: ResourceStore.fullResources,
    get: resourceGetSingle,
    fromJS: ResourceModel.fromJS
  },
  news: {
    shorts: StoryStore.storiesMap,
    fulls: StoryStore.storiesMap,
    get: newsGetSingle,
    fromJS: StoryModel.fromJS
  },
  events: {
    shorts: StoryStore.storiesMap,
    fulls: StoryStore.storiesMap,
    get: eventGetSingle,
    fromJS: StoryModel.fromJS
  },
  faculty: {
    shorts: ExpertiseStore.facultyMap,
    fulls: ExpertiseStore.fullFaculties,
    get: facultyGetSingle,
    fromJS: FacultyModel.fromJS
  }
}

// Project subtypes share the same store as project itself
adapters.ip = adapters.project
adapters.research = adapters.project
adapters.companies = adapters.project

export default async function openPopout (type, id) {
  const adapter = adapters[type]

  if (!adapter) {
    // no adapter matched
    UiStore.popoutElement = null
    return
  }

  if (adapter.fulls.get(id)) {
    UiStore.popoutElement = adapter.fulls.get(id)
  } else if (adapter.shorts.get(id)) {
    UiStore.popoutElement = adapter.shorts.get(id)
  } else {
    // For now, we're going to AJAX request a full element simply when it has
    // not yet loaded. In the future, when short is optimized to contain only
    // necessary information, we may want to always do an AJAX request to get
    // detailed information.
    try {
      var response = await adapter.get(id)
    } catch (err) {
      if (err.code === 404) {
        UiStore.popoutElement = new NotFoundModel()
        return
      } else {
        throw err
      }
    }

    const fullElement = adapter.fromJS(response)

    adapter.fulls.set(id, fullElement)

    // set new full element as popout
    UiStore.popoutElement = fullElement
  }

  setTitleInHistoryStack()
}

// The reason this can't be a MobX autorun is because closing a popout, which
// modifies popoutElement, would trigger the function and set the title for the
// wrong page. Setting title here whenever popoutElement is set makes sense.
//
// The title history stack is used for the BackLink text.
function setTitleInHistoryStack () {
  HistoryTracker.setTitleForCurrentLocation(UiStore.popoutElement.name)
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/openPopout.js